export const ID = 'c413eead-a649-4e0d-8a66-40f7f804370b';

export const NAME = 'Classic Unit Categories';
